
import { Button } from "@/components/ui/button";
import { NewsArticle } from "./types";
import { useState, useEffect } from "react";
import { FormFields } from "./components/FormFields";
import { ImageUpload } from "./components/ImageUpload";
import { ArticleStatus } from "./components/ArticleStatus";

interface NewsFormProps {
  article: Omit<NewsArticle, "id">;
  onChange: (article: Omit<NewsArticle, "id">) => void;
  onSubmit: () => void;
}

export function NewsForm({ article, onChange, onSubmit }: NewsFormProps) {
  const [imagePreview, setImagePreview] = useState<string | null>(article.image);

  // Update image preview when article changes from outside
  useEffect(() => {
    setImagePreview(article.image);
  }, [article.image]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    onChange({ ...article, [name]: value });
  };

  const handleSwitchChange = () => {
    onChange({ ...article, isPublic: !article.isPublic });
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ ...article, category: e.target.value as "news" | "tech" });
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Create a FileReader to convert the image to a Data URL
      const reader = new FileReader();
      
      reader.onloadend = () => {
        // reader.result is the base64 string representation of the image
        const imageDataUrl = reader.result as string;
        setImagePreview(imageDataUrl);
        onChange({ ...article, image: imageDataUrl });
      };
      
      reader.onerror = () => {
        console.error("FileReader error:", reader.error);
      };
      
      // Read the file as a Data URL
      reader.readAsDataURL(file);
    }
  };

  const handleImageError = () => {
    console.error("Preview image failed to load");
    setImagePreview(null);
  };

  return (
    <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
      <FormFields 
        title={article.title}
        description={article.description}
        content={article.content}
        onChange={handleInputChange}
      />
      
      <ImageUpload 
        imagePreview={imagePreview}
        onImageChange={handleImageChange}
        onImageError={handleImageError}
      />
      
      <ArticleStatus 
        isPublic={article.isPublic} 
        onChange={handleSwitchChange} 
      />
      
      <Button type="submit" className="w-full">
        Προσθήκη Άρθρου
      </Button>
    </form>
  );
}
